import React from "react";
import { formatDayOffset, timetableDayOffsets } from "shared/utils/fieldsHelper/timetableEntryFields";
import { type DropdownWithoutOptionsProps } from "../models";
import BaseReactSelectDropdown from "./BaseReactSelectDropdown";

interface Option {
  text: string
  value: number
}

const options: Option[] = timetableDayOffsets.map(dayOffset => ({
  text: formatDayOffset(dayOffset, RESX.Show.DateOfEvent),
  value: dayOffset
}));

const TimetableDayOffsetDropdown = (props: DropdownWithoutOptionsProps<number, number>) => {
  const value = options.find(o => o.value === props.value);

  return <BaseReactSelectDropdown
    excludeKeys={props.excludeKeys}
    options={options}
    value={value}
    onChange={v => props.onChange(v.value)}
    onEsc={props.onEsc}
    getLabel={v => v.text}
    getValue={v => v.value}
    config={{
      isSearchable: false,
      shouldRenderSelectedValue: true,
      ...props.config,
    }}
  />;
};

export default TimetableDayOffsetDropdown;
